/*****************************************************************************************
 * 설명 : 왼쪽 메뉴
 * URI :
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from "react-router-dom";

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const Snb = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const history = useNavigate();

  const [menuIndex, setMenuIndex] = useState(-1);

  const menuList = useSelector(state => state?.menuList);
  const currentMenu = useSelector(state => state?.menuList?.current);

  /***************************************************************************************
   * 설명 : 서브메뉴 HTML
  ***************************************************************************************/
  function SubMenu(subProps) {
    let search = window.location.search?.replace(/\?/g, '');

    return (
      <li
        className={subProps?.linkUrl === window.location.pathname  && (subProps?.queryString ?? '') === search ? 'on' : ''}
      >
        <NavLink to={subProps.linkUrl} className="subtitle">
          <div className="icon">
            <ArrowForwardIosIcon />
          </div>
          {subProps.pageName}
        </NavLink>
      </li>
    );
  }

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <div className="admin-snb">

      <div className="admin-snbmenu">
        <ul className="admin-mainmenu">
          {menuList?.menu?.length > 0 && menuList?.menu?.map((menu, index) => {
            let search = window.location.search?.replace(/\?/g, '');

            if(parseInt(menu.isMainmenuView) === 0) return '';
            else {
              let check = menu?.children !== undefined ? menu?.children?.filter((item) => item.linkUrl === window.location.pathname && (item.queryString ?? '') === search ) : '';
              let isOpen = false;
              if( check.length > 0 ) isOpen = true;

              let childrenCount = menu.children.filter((subItem) => parseInt(subItem.isMainmenuView) === 1);

              return (
                <li
                  key={index}
                  className={ isOpen || menu?.seq === menuIndex || menu?.seq === currentMenu?.seq ? 'menu open' : 'menu'}
                  onClick={(event) => {
                    setMenuIndex(menu.seq);

                    if( menu.children === undefined || childrenCount.length < 1 ) {
                      if( menu.isLinkOpen === 'N')
                        window.open(menu.linkUrl + (menu.queryString === '' ? '' : '?' + menu.queryString), menu.seq, 'resizable=no, toolbar=no, scrollbars=auto, menubar=no, directories=no, location=no, width=1200, height=800, left=0, top=0' )
                      else
                        history(menu.linkUrl);
                    }
                  }}
                >
                  <div className="depth1 clearfix">
                    <div className="icon1"><span dangerouslySetInnerHTML={{ __html: menu.icon }}></span></div>
                    <div className="title">{menu.pageName}</div>
                    <div className="icon2"><ArrowForwardIosIcon/></div>
                  </div>

                  {
                    menu.children !== undefined && childrenCount.length > 0 &&
                    <ul className="submenu">
                      {
                        menu?.children?.map((submenu, index) => {
                          let url = (submenu.queryString ?? '') === '' ? submenu.linkUrl : submenu.linkUrl + '?' + submenu.queryString;

                          if(parseInt(submenu.isMainmenuView) === 0)
                            return ''
                          else {
                            return (
                              <SubMenu
                                pageName={submenu.pageName}
                                linkUrl={url}
                                queryString={submenu.queryString}
                                key={submenu.seq + '_' + index}
                              />
                            )
                          }
                        })
                      }
                    </ul>
                  }
                </li>
              )
            }
          })}
        </ul>

      </div>

    </div>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Snb;